import {
  Collapse,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useEffect } from "react";
import { AppTheme } from "../context/MainContextProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export function RopMenuDashboardAccordion(props: {
  theme: AppTheme;
  disabled?: boolean;
  children: React.ReactNode;
  title: string;
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  isAccordionitem?: boolean;
}) {
  const { theme, isExpanded, setIsExpanded, children, isAccordionitem } = props;
  useEffect(() => {
    if (props.disabled) {
      setIsExpanded(false);
    }
  }, [props.disabled]);
  return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          sx={{ paddingLeft: isAccordionitem ? "32px" : undefined }}
          disabled={props.disabled}
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <div className="pe-2">
            <FontAwesomeIcon
              size="sm"
              icon={faAngleRight}
              color={isExpanded ? theme.primaryTextColor : "#454C52"}
              style={{
                transform: isExpanded ? "rotate(90deg)" : "",
                transition: "all 0.2s linear",
              }}
              rotate={"90deg"}
            />
          </div>

          <ListItemText primary={props.title} />
        </ListItemButton>
      </ListItem>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <div className="d-flex flex-row justify-content-around flex-wrap">
          {children}
        </div>
      </Collapse>
      <Divider
        sx={{
          backgroundColor: theme.secondaryTextColor,
        }}
      />
    </>
  );
}
